import { styled } from "@mui/material/styles";
import { DataGrid, DataGridProps } from "@mui/x-data-grid";
import { theme as _theme } from "../../helpers/theme";
import { DataGridPropsWithDefaultValues } from "@mui/x-data-grid/models/props/DataGridProps";
import "./styled-table.css";
import { TABLES_LOCALE_TEXT } from "../../helpers/tables-locale-text";

export const StyledTable = styled((props: DataGridProps) => (
  <DataGrid
    localeText={TABLES_LOCALE_TEXT}
    getRowClassName={() => `row-style`}
    {...props}
  />
))(({ theme }) => ({
  ".row-style": {
    backgroundColor: `#fff`,
    borderRadius: `8px`,
    fontFamily: `${_theme.fonts.interRegular}`,
  },
}));
